var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface2434434"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(43.529412%,46.27451%,49.411765%)",
      fillOpacity: 1
    },
    d: "M 24 2 C 17.273438 2 12 7.273438 12 14 L 12 16 C 9.800781 16 8 17.800781 8 20 L 8 40 C 8 42.199219 9.800781 44 12 44 L 36 44 C 38.199219 44 40 42.199219 40 40 L 40 20 C 40 17.800781 38.199219 16 36 16 L 36 14 C 36 7.273438 30.726562 2 24 2 Z M 24 6 C 28.484375 6 32 9.515625 32 14 L 32 16 L 16 16 L 16 14 C 16 9.515625 19.515625 6 24 6 Z M 12 20 L 36 20 L 36 40 L 12 40 Z M 16 28 C 14.894531 28 14 28.894531 14 30 C 14 31.105469 14.894531 32 16 32 C 17.105469 32 18 31.105469 18 30 C 18 28.894531 17.105469 28 16 28 Z M 24 28 C 22.894531 28 22 28.894531 22 30 C 22 31.105469 22.894531 32 24 32 C 25.105469 32 26 31.105469 26 30 C 26 28.894531 25.105469 28 24 28 Z M 32 28 C 30.894531 28 30 28.894531 30 30 C 30 31.105469 30.894531 32 32 32 C 33.105469 32 34 31.105469 34 30 C 34 28.894531 33.105469 28 32 28 Z M 32 28 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.85cffc8f3593e661e87804b6fba47520.svg";
export { ForwardRef as ReactComponent };